const BASE_URL = "https://ceo.iosx.in/api/";
export default BASE_URL;
